import { combineReducers } from 'redux'
import { user } from './user'
import { routerReducer } from 'react-router-redux'

const reducers = combineReducers({ routing: routerReducer, user })

export default reducers



// WEBPACK FOOTER //
// ./src/reducers/index.js